// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import ApiUrl from "../Environment/ApiUrl";
// import { Plus, Search, Trash2, Edit2 } from "lucide-react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// function Users() {
//   // State for users data
//   const [usersData, setUsersData] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   // Add modal state
//   const [showAddModal, setShowAddModal] = useState(false);

//   // Form data state
//   const [formData, setFormData] = useState({
//     user_id: "",
//     user_Name: "",
//     password: "",
//     mobile_Number: "",
//     role: "",
//     branch_Name: "",
//     status: "Active",
//   });

//   // Form validation errors
//   const [formErrors, setFormErrors] = useState({
//     user_id: "",
//     user_Name: "",
//     password: "",
//     mobile_Number: "",
//     role: "",
//     branch_Name: "",
//   });

//   // Update modal state
//   const [updateData, setUpdateData] = useState({
//     user_id: "",
//     user_Name: "",
//     password: "",
//     mobile_Number: "",
//     role: "",
//     branch_Name: "",
//     status: "Active",
//   });
//   const [updateId, setUpdateId] = useState("");
//   const [showUpdateModal, setShowUpdateModal] = useState(false);

//   // Delete modal state
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState("");
//   const [deleteName, setDeleteName] = useState("");
//   const [branch, setBranchData] = useState([]);

//   // Search and pagination state
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);

//   // Fetch data
//   useEffect(() => {
//     fetchData();
//     fetchbranch();
//   }, []);

//   const fetchData = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(`${ApiUrl}/user_data.php`);
//       setUsersData(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setUsersData([]);
//       toast.error("Failed to fetch User");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchbranch = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(`${ApiUrl}/branch_data.php`);
//       setBranchData(response.data?.data || []);
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       toast.error("Failed to fetch branch");
//       setBranchData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Form validation
//   const validateForm = () => {
//     const errors = {};
//     let isValid = true;

//     if (!formData.user_id.trim()) {
//       errors.user_id = "User ID is required";
//       isValid = false;
//     }
//     if (!formData.user_Name.trim()) {
//       errors.user_Name = "User Name is required";
//       isValid = false;
//     }
//     if (!formData.password.trim()) {
//       errors.password = "Password is required";
//       isValid = false;
//     }
//     if (!formData.mobile_Number.trim()) {
//       errors.mobile_Number = "Mobile Number is required";
//       isValid = false;
//     } else if (!/^\d{10}$/.test(formData.mobile_Number)) {
//       errors.mobile_Number = "Mobile Number must be 10 digits";
//       isValid = false;
//     }
//     if (!formData.role.trim()) {
//       errors.role = "Role is required";
//       isValid = false;
//     }
//     if (!formData.branch_Name.trim()) {
//       errors.branch_Name = "Branch is required";
//       isValid = false;
//     }

//     setFormErrors(errors);
//     return isValid;
//   };

//   // Add user functions
//   const openAddModal = () => setShowAddModal(true);
//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setFormErrors({
//       user_id: "",
//       user_Name: "",
//       password: "",
//       mobile_Number: "",
//       role: "",
//       branch_Name: "",
//     });
//   };

//   const handleAddConfirm = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     try {
//       setIsLoading(true);
//       await axios.post(`${ApiUrl}/user_data.php`, formData);
//       toast.success("user added successfully!");
//       closeAddModal();
//       fetchData();
//       setFormData({
//         user_id: "",
//         user_Name: "",
//         password: "",
//         mobile_Number: "",
//         role: "",
//         branch_Name: "",
//         status: "Active",
//       });
//     } catch (error) {
//       console.error("Error adding user:", error.message);
//       toast.error("Error adding user");
//     } finally {
//       setIsLoading(false);
//     }
//   };



//   // Update user functions
//   const openUpdateModal = (id, data) => {
//     setUpdateId(id);
//     setUpdateData({
//       user_id: data.user_id,
//       user_Name: data.user_Name,
//       password: data.password,
//       mobile_Number: data.mobile_Number,
//       role: data.role,
//       branch_Name: data.branch_Name,
//       status: data.status,
//     });
//     setShowUpdateModal(true);
//   };

//   const closeUpdateModal = () => setShowUpdateModal(false);

//   const handleUpdateSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setIsLoading(true);
//       await axios.put(`${ApiUrl}/user_data.php`, {
//         id: updateId,
//         ...updateData,
//       });
//       toast.success("User updated successfully!");
//       closeUpdateModal();
//       fetchData();
//     } catch (error) {
//       console.error("Error updating user:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Delete user functions
//   const openDeleteModal = (id, userId) => {
//     setDeleteId(id);
//     setDeleteName(userId);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => setShowDeleteModal(false);

//   const handleDelete = async () => {
//     try {
//       setIsLoading(true);
//       await axios.delete(`${ApiUrl}/user_data.php/${deleteId}`);
//       toast.success(`User ${deleteName} deleted successfully!`);
//       closeDeleteModal();
//       fetchData();
//     } catch (error) {
//       console.error("Error deleting user:", error.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Search and pagination logic
//   const filteredUsers = (usersData || []).filter((user) =>
//     Object.values(user)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const currentUsers = filteredUsers.slice(
//     startIndex,
//     startIndex + itemsPerPage
//   );

//   return (
//     <>
//       <div className="bg-white font-sans">
//         <ToastContainer
//           position="top-right"
//           autoClose={3000}
//           hideProgressBar={false}
//           closeOnClick
//           pauseOnHover
//         />
//         {/* Header */}
//         <div className="p-3 p-md-4 bg-white">
//           <div className="d-flex justify-content-between align-items-center">
//             <h2 className="m-0 fs-5 fw-semibold text-dark">Users</h2>
//             <button
//               className="btn btn-danger d-flex align-items-center gap-2"
//               onClick={openAddModal}
//             >
//               <Plus size={18} /> Add User
//             </button>
//           </div>
//         </div>

//         {/* Main Card Container */}
//         <div className="card mx-3 mx-md-4 border">
//           {/* Controls Row */}
//           <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
//             {/* Show All Dropdown */}
//             <div
//               className="d-flex align-items-center gap-2"
//               style={{ height: "36px", width: "120px" }}
//             >
//               <div
//                 className="d-flex align-items-center justify-content-center"
//                 style={{ height: "28px", width: "14px" }}
//               >
//                 <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
//                   <rect x="1" y="1" width="3" height="3" fill="#666" />
//                   <rect x="1" y="5" width="3" height="3" fill="#666" />
//                   <rect x="1" y="9" width="3" height="2" fill="#666" />
//                   <rect x="5" y="1" width="6" height="1" fill="#666" />
//                   <rect x="5" y="3" width="6" height="1" fill="#666" />
//                   <rect x="5" y="5" width="6" height="1" fill="#666" />
//                   <rect x="5" y="7" width="6" height="1" fill="#666" />
//                   <rect x="5" y="9" width="6" height="1" fill="#666" />
//                 </svg>
//               </div>
//               <select
//                 className="border-0 bg-transparent text-dark form-select form-select-sm"
//                 style={{
//                   boxShadow: "none",
//                   outline: "none",
//                   lineHeight: "1.1",
//                   height: "28px",
//                   cursor: "pointer",
//                   width: "80px",
//                   paddingTop: "0",
//                   paddingBottom: "0",
//                 }}
//                 value={itemsPerPage}
//                 onChange={(e) => {
//                   setItemsPerPage(Number(e.target.value));
//                   setCurrentPage(1);
//                 }}
//               >
//                 <option value="5">Show 5</option>
//                 <option value="10">Show 10</option>
//                 <option value="25">Show 25</option>
//               </select>
//             </div>

//             {/* Search */}
//             <div className="position-relative" style={{ width: "280px" }}>
//               <input
//                 type="text"
//                 placeholder="Search"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-100 ps-3 pe-5 py-2 border rounded form-control"
//               />
//               <Search
//                 size={18}
//                 className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
//                 style={{ pointerEvents: "none" }}
//               />
//             </div>
//           </div>

//           {/* Table Container */}
//           <div className="card-body p-0">
//             {/* Table */}
//             <div className="table-responsive">
//               <table className="table table-hover mb-0 text-center">
//                 <thead>
//                   <tr>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       S.No
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       User ID
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       User Name
//                     </th>
                   
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       Mobile Number
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       Role
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       Branch
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       Status
//                     </th>
//                     <th
//                       style={{ backgroundColor: "#d3d3d3" }}
//                       className="p-3 fw-semibold small"
//                     >
//                       Action
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentUsers.length > 0 ? (
//                     currentUsers.map((user, index) => (
//                       <tr key={index} style={{ fontSize: "14px" }}>
//                         <td>{startIndex + index + 1}</td>
//                         <td>{user.user_id}</td>
//                         <td>{user.user_Name}</td>
                
//                         <td>{user.mobile_Number}</td>
//                         <td>{user.role}</td>
//                         <td>{user.branch_Name}</td>
//                         <td className="small">
//                           <span
//                             className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${
//                               user.status === "Active"
//                                 ? "bg-success bg-opacity-10 text-success"
//                                 : "bg-danger bg-opacity-10 text-danger"
//                             }`}
//                           >
//                             {user.status === "Active"} {user.status}
//                           </span>
//                         </td>
//                         <td className="small">
//                           <div className="d-flex justify-content-center">
//                             <button
//                               onClick={() =>
//                                 openDeleteModal(user.id, user.user_id)
//                               }
//                               className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                               disabled={isLoading}
//                             >
//                               <Trash2 size={16} />
//                             </button>
//                             <button
//                               onClick={() => openUpdateModal(user.id, user)}
//                               className="p-1 border-0 bg-transparent cursor-pointer text-muted"
//                               disabled={isLoading}
//                             >
//                               <Edit2 size={16} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan={9} className="text-center p-5">
//                         No data available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {itemsPerPage < filteredUsers.length && (
//               <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.max(prev - 1, 1))
//                   }
//                   disabled={currentPage === 1}
//                   className={`btn btn-sm d-flex align-items-center gap-2 ${
//                     currentPage === 1
//                       ? "bg-light text-muted"
//                       : "bg-white text-dark"
//                   }`}
//                 >
//                   <FaChevronLeft size={14} />
//                   <span className="ms-1 d-none d-md-inline">Previous</span>
//                 </button>

//                 <div className="d-flex gap-1">
//                   {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                     let pageNum;
//                     if (totalPages <= 5) {
//                       pageNum = i + 1;
//                     } else if (currentPage <= 3) {
//                       pageNum = i + 1;
//                     } else if (currentPage >= totalPages - 2) {
//                       pageNum = totalPages - 4 + i;
//                     } else {
//                       pageNum = currentPage - 2 + i;
//                     }

//                     return (
//                       <button
//                         key={pageNum}
//                         onClick={() => setCurrentPage(pageNum)}
//                         disabled={isLoading}
//                         className={`btn btn-sm ${
//                           pageNum === currentPage
//                             ? "bg-danger bg-opacity-10 text-danger"
//                             : "bg-white text-dark"
//                         }`}
//                         style={{ width: "32px", height: "32px" }}
//                       >
//                         {pageNum}
//                       </button>
//                     );
//                   })}
//                   {totalPages > 5 && currentPage < totalPages - 2 && (
//                     <span className="px-2 py-1">...</span>
//                   )}
//                   {totalPages > 5 && currentPage < totalPages - 2 && (
//                     <button
//                       onClick={() => setCurrentPage(totalPages)}
//                       disabled={isLoading}
//                       className={`btn btn-sm ${
//                         totalPages === currentPage
//                           ? "bg-danger bg-opacity-10 text-danger"
//                           : "bg-white text-dark"
//                       }`}
//                       style={{ width: "32px", height: "32px" }}
//                     >
//                       {totalPages}
//                     </button>
//                   )}
//                 </div>

//                 <button
//                   onClick={() =>
//                     setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//                   }
//                   disabled={currentPage === totalPages}
//                   className={`btn btn-sm d-flex align-items-center gap-2 ${
//                     currentPage === totalPages
//                       ? "bg-light text-muted"
//                       : "bg-white text-dark"
//                   }`}
//                 >
//                   <span className="ms-1 d-none d-md-inline">Next</span>
//                   <FaChevronRight size={14} />
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Add User Modal */}
//         <div
//           className={`modal fade ${showAddModal ? "show" : ""}`}
//           style={{
//             display: showAddModal ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//           aria-labelledby="addUserModalLabel"
//           aria-hidden={!showAddModal}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content rounded"
//               style={{ backgroundColor: "rgb(255, 240, 245)" }}
//             >
//               <div className="modal-header bg-pink-light border-bottom-0">
//                 <h5 className="modal-title m-0  fw-semibold">Add User</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={closeAddModal}
//                   disabled={isLoading}
//                 ></button>
//               </div>

//               <div className="modal-body bg-pink-light">
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       User ID
//                     </label>
//                     <input
//                       type="text"
//                       className={`form-control form-control-sm ${
//                         formErrors.user_id ? "is-invalid" : ""
//                       }`}
//                       name="user_id"
//                       value={formData.user_id}
//                       onChange={(e) =>
//                         setFormData({ ...formData, user_id: e.target.value })
//                       }
//                       placeholder="Enter User ID"
//                       disabled={isLoading}
//                     />
//                     {formErrors.user_id && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.user_id}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       User Name
//                     </label>
//                     <input
//                       type="text"
//                       className={`form-control form-control-sm ${
//                         formErrors.user_Name ? "is-invalid" : ""
//                       }`}
//                       name="user_Name"
//                       value={formData.user_Name}
//                       onChange={(e) =>
//                         setFormData({ ...formData, user_Name: e.target.value })
//                       }
//                       placeholder="Enter User Name"
//                       disabled={isLoading}
//                     />
//                     {formErrors.user_Name && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.user_Name}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Mobile Number
//                     </label>
//                     <input
//                       type="tel"
//                       className={`form-control form-control-sm ${
//                         formErrors.mobile_Number ? "is-invalid" : ""
//                       }`}
//                       name="mobile_Number"
//                       value={formData.mobile_Number}
//                       onChange={(e) => {
//                         // Remove all non-digit characters
//                         const onlyDigits = e.target.value.replace(/\D/g, "");
//                         setFormData({ ...formData, mobile_Number: onlyDigits });
//                       }}
//                       placeholder="Enter Mobile Number"
//                       disabled={isLoading}
//                       maxLength="10"
//                     />

//                     {formErrors.mobile_Number && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.mobile_Number}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       className={`form-control form-control-sm ${
//                         formErrors.password ? "is-invalid" : ""
//                       }`}
//                       name="password"
//                       value={formData.password}
//                       onChange={(e) =>
//                         setFormData({ ...formData, password: e.target.value })
//                       }
//                       placeholder="Enter Password"
//                       disabled={isLoading}
//                     />
//                     {formErrors.password && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.password}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Role
//                     </label>
//                     <select
//                       className={`form-select form-select-sm ${
//                         formErrors.role ? "is-invalid" : ""
//                       }`}
//                       name="role"
//                       value={formData.role}
//                       onChange={(e) =>
//                         setFormData({ ...formData, role: e.target.value })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="" disabled>
//                         Select Role
//                       </option>
//                       <option>Admin</option>
//                       <option>Manager</option>
//                       <option >staff</option>
//                     </select>
//                     {formErrors.role && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.role}
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Branch
//                     </label>
//                     <select
//                       className={`form-select form-select-sm ${
//                         formErrors.branch_Name ? "is-invalid" : ""
//                       }`}
//                       name="branch_Name"
//                       value={formData.branch_Name}
//                       onChange={(e) =>
//                         setFormData({
//                           ...formData,
//                           branch_Name: e.target.value,
//                         })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="" disabled>
//                         Select Branch
//                       </option>
//                       {branch.map((branch, index) => (
//                         <option key={index} value={branch.branch_name}>
//                           {branch.branch_name}
//                         </option>
//                       ))}
//                     </select>
//                     {formErrors.branch_Name && (
//                       <div className="invalid-feedback d-block small">
//                         {formErrors.branch_Name}
//                       </div>
//                     )}
//                   </div>

//                   <div className="col-md-6 mt-3">
//                     <label className="form-label small fw-medium">Status</label>
//                     <select
//                       className="form-select form-select-sm"
//                       name="status"
//                       value={formData.status}
//                       onChange={(e) =>
//                         setFormData({ ...formData, status: e.target.value })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer border-top-0">
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-danger"
//                   onClick={closeAddModal}
//                   disabled={isLoading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-success"
//                   onClick={handleAddConfirm}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm me-2"
//                         role="status"
//                         aria-hidden="true"
//                       ></span>
//                       Saving...
//                     </>
//                   ) : (
//                     "Confirm"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Update User Modal */}
//         <div
//           className={`modal fade ${showUpdateModal ? "show" : ""}`}
//           style={{
//             display: showUpdateModal ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//           aria-labelledby="updateUserModalLabel"
//           aria-hidden={!showUpdateModal}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               className="modal-content rounded"
//               style={{ backgroundColor: "rgb(255, 240, 245)" }}
//             >
//               <div className="modal-header bg-pink-light border-bottom-0">
//                 <h5 className="modal-title m-0  fw-semibold">Update User</h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   onClick={closeUpdateModal}
//                   disabled={isLoading}
//                 ></button>
//               </div>

//               <div className="modal-body bg-pink-light">
//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       User ID
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       name="user_id"
//                       value={updateData.user_id}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           user_id: e.target.value,
//                         })
//                       }
//                       placeholder="Enter User ID"
//                       disabled={isLoading}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium">
//                       User Name
//                     </label>
//                     <input
//                       type="text"
//                       className="form-control form-control-sm"
//                       name="user_Name"
//                       value={updateData.user_Name}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           user_Name: e.target.value,
//                         })
//                       }
//                       placeholder="Enter User Name"
//                       disabled={isLoading}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Mobile Number
//                     </label>
//                     <input
//                       type="tel"
//                       className="form-control form-control-sm"
//                       name="mobile_Number"
//                       value={updateData.mobile_Number}
//                       onChange={(e) => {
//                         // Keep only digits, max 10
//                         const digitsOnly = e.target.value
//                           .replace(/\D/g, "")
//                           .slice(0, 10);
//                         setUpdateData({
//                           ...updateData,
//                           mobile_Number: digitsOnly,
//                         });
//                       }}
//                       placeholder="Enter Mobile Number"
//                       disabled={isLoading}
//                       maxLength={10}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Password
//                     </label>
//                     <input
//                       type="password"
//                       className="form-control form-control-sm"
//                       name="password"
//                       value={updateData.password}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           password: e.target.value,
//                         })
//                       }
//                       placeholder="Enter Password"
//                       disabled={isLoading}
//                     />
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Role
//                     </label>
//                     <select
//                       className="form-select form-select-sm"
//                       name="role"
//                       value={updateData.role}
//                       onChange={(e) =>
//                         setUpdateData({ ...updateData, role: e.target.value })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="">Select Role</option>
//                       <option>Admin</option>
//                       <option>Manager</option>
//                       <option>Staff</option>
//                     </select>
//                   </div>
//                   <div className="col-md-6">
//                     <label className="form-label small fw-medium mt-2">
//                       Branch
//                     </label>
//                     <select
//                       className="form-select form-select-sm"
//                       name="branch_Name"
//                       value={updateData.branch_Name}
//                       onChange={(e) =>
//                         setUpdateData({
//                           ...updateData,
//                           branch_Name: e.target.value,
//                         })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="" disabled>
//                         Select Branch
//                       </option>
//                       {branch.map((item, index) => (
//                         <option key={index} value={item.branch_name}>
//                           {item.branch_name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <div className="col-md-6 mt-3">
//                     <label className="form-label small fw-medium mt-2">
//                       Status
//                     </label>
//                     <select
//                       className="form-select form-select-sm"
//                       name="status"
//                       value={updateData.status}
//                       onChange={(e) =>
//                         setUpdateData({ ...updateData, status: e.target.value })
//                       }
//                       disabled={isLoading}
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="modal-footer border-top-0">
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-danger"
//                   onClick={closeUpdateModal}
//                   disabled={isLoading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-sm btn-success"
//                   onClick={handleUpdateSubmit}
//                   disabled={isLoading}
//                 >
//                   {isLoading ? (
//                     <>
//                       <span
//                         className="spinner-border spinner-border-sm me-2"
//                         role="status"
//                         aria-hidden="true"
//                       ></span>
//                       Updating...
//                     </>
//                   ) : (
//                     "Update"
//                   )}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Delete Confirmation Modal */}
//         <div
//           className={`modal fade ${showDeleteModal ? "show" : ""}`}
//           style={{
//             display: showDeleteModal ? "block" : "none",
//             backgroundColor: "rgba(0,0,0,0.5)",
//           }}
//           tabIndex="-1"
//           aria-labelledby="deleteConfirmModalLabel"
//           aria-modal="true"
//         >
//           <div className="modal-dialog modal-dialog-centered modal-confirm">
//             <div className="modal-content">
//               <div className="modal-body text-center">
//                 <div className="d-flex justify-content-center mb-3">
//                   <div
//                     className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
//                     style={{ width: "80px", height: "80px" }}
//                   >
//                     <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
//                   </div>
//                 </div>
//                 <h4 className="modal-title mb-3">Are you sure?</h4>
//                 <h6 className="mb-4">
//                   Do you really want to delete user{" "}
//                   <span className="text-primary">({deleteName}</span>
//                   )?
//                 </h6>
//                 <div className="d-flex btn-group">
//                   <button
//                     type="button"
//                     className="btn btn-secondary btn-sm flex-grow-1"
//                     onClick={closeDeleteModal}
//                     disabled={isLoading}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm flex-grow-1 mx-2"
//                     onClick={handleDelete}
//                     disabled={isLoading}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span
//                           className="spinner-border spinner-border-sm me-2"
//                           role="status"
//                           aria-hidden="true"
//                         ></span>
//                         Deleting...
//                       </>
//                     ) : (
//                       "Delete"
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Users;



import axios from "axios";
import React, { useEffect, useState } from "react";
import ApiUrl from "../Environment/ApiUrl";
import { Plus, Search, Trash2, Edit2 } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Users() {
  // State for users data
  const [usersData, setUsersData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Add modal state
  const [showAddModal, setShowAddModal] = useState(false);

  // Form data state
  const [formData, setFormData] = useState({
    user_id: "",
    user_Name: "",
    password: "",
    mobile_Number: "",
    role: "",
    branch_Name: "",
    status: "Active",
  });

  // Form validation errors
  const [formErrors, setFormErrors] = useState({
    user_id: "",
    user_Name: "",
    password: "",
    mobile_Number: "",
    role: "",
    branch_Name: "",
  });

  // Update modal state
  const [updateData, setUpdateData] = useState({
    user_id: "",
    user_Name: "",
    password: "",
    mobile_Number: "",
    role: "",
    branch_Name: "",
    status: "Active",
  });
  const [updateId, setUpdateId] = useState("");
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // Delete modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");
  const [branch, setBranchData] = useState([]);

  // Search and pagination state
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  // Privileges state
  const [privileges, setPrivileges] = useState(null);

  // Fetch privileges from localStorage
  useEffect(() => {
    const getaccess = localStorage.getItem("role");
    setPrivileges(getaccess);
  }, []);

  // Fetch data
  useEffect(() => {
    fetchData();
    fetchbranch();
  }, []);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${ApiUrl}/user_data.php`);
      setUsersData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setUsersData([]);
      toast.error("Failed to fetch User");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchbranch = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${ApiUrl}/branch_data.php`);
      setBranchData(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Failed to fetch branch");
      setBranchData([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Form validation
  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.user_id.trim()) {
      errors.user_id = "User ID is required";
      isValid = false;
    }
    if (!formData.user_Name.trim()) {
      errors.user_Name = "User Name is required";
      isValid = false;
    }
    if (!formData.password.trim()) {
      errors.password = "Password is required";
      isValid = false;
    }
    if (!formData.mobile_Number.trim()) {
      errors.mobile_Number = "Mobile Number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.mobile_Number)) {
      errors.mobile_Number = "Mobile Number must be 10 digits";
      isValid = false;
    }
    if (!formData.role.trim()) {
      errors.role = "Role is required";
      isValid = false;
    }
    if (!formData.branch_Name.trim()) {
      errors.branch_Name = "Branch is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  // Add user functions
  const openAddModal = () => setShowAddModal(true);
  const closeAddModal = () => {
    setShowAddModal(false);
    setFormErrors({
      user_id: "",
      user_Name: "",
      password: "",
      mobile_Number: "",
      role: "",
      branch_Name: "",
    });
  };

  const handleAddConfirm = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setIsLoading(true);
      await axios.post(`${ApiUrl}/user_data.php`, formData);
      toast.success("user added successfully!");
      closeAddModal();
      fetchData();
      setFormData({
        user_id: "",
        user_Name: "",
        password: "",
        mobile_Number: "",
        role: "",
        branch_Name: "",
        status: "Active",
      });
    } catch (error) {
      console.error("Error adding user:", error.message);
      toast.error("Error adding user");
    } finally {
      setIsLoading(false);
    }
  };



  // Update user functions
  const openUpdateModal = (id, data) => {
    setUpdateId(id);
    setUpdateData({
      user_id: data.user_id,
      user_Name: data.user_Name,
      password: data.password,
      mobile_Number: data.mobile_Number,
      role: data.role,
      branch_Name: data.branch_Name,
      status: data.status,
    });
    setShowUpdateModal(true);
  };

  const closeUpdateModal = () => setShowUpdateModal(false);

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await axios.put(`${ApiUrl}/user_data.php`, {
        id: updateId,
        ...updateData,
      });
      toast.success("User updated successfully!");
      closeUpdateModal();
      fetchData();
    } catch (error) {
      console.error("Error updating user:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Delete user functions
  const openDeleteModal = (id, userId) => {
    setDeleteId(id);
    setDeleteName(userId);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => setShowDeleteModal(false);

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      await axios.delete(`${ApiUrl}/user_data.php/${deleteId}`);
      toast.success(`User ${deleteName} deleted successfully!`);
      closeDeleteModal();
      fetchData();
    } catch (error) {
      console.error("Error deleting user:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Search and pagination logic
  const filteredUsers = (usersData || []).filter((user) =>
    Object.values(user)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentUsers = filteredUsers.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <div className="bg-white font-sans">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
        />
        {/* Header */}
        <div className="p-3 p-md-4 bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="m-0 fs-5 fw-semibold text-dark">Users</h2>
            {(privileges === 'Admin' || privileges === 'Staff' || privileges === 'Manager') && (
              <button
                className="btn btn-danger d-flex align-items-center gap-2"
                onClick={openAddModal}
              >
                <Plus size={18} /> Add User
              </button>
            )}
          </div>
        </div>

        {/* Main Card Container */}
        <div className="card mx-3 mx-md-4 border">
          {/* Controls Row */}
          <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
            {/* Show All Dropdown */}
            <div
              className="d-flex align-items-center gap-2"
              style={{ height: "36px", width: "120px" }}
            >
              <div
                className="d-flex align-items-center justify-content-center"
                style={{ height: "28px", width: "14px" }}
              >
                <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                  <rect x="1" y="1" width="3" height="3" fill="#666" />
                  <rect x="1" y="5" width="3" height="3" fill="#666" />
                  <rect x="1" y="9" width="3" height="2" fill="#666" />
                  <rect x="5" y="1" width="6" height="1" fill="#666" />
                  <rect x="5" y="3" width="6" height="1" fill="#666" />
                  <rect x="5" y="5" width="6" height="1" fill="#666" />
                  <rect x="5" y="7" width="6" height="1" fill="#666" />
                  <rect x="5" y="9" width="6" height="1" fill="#666" />
                </svg>
              </div>
              <select
                className="border-0 bg-transparent text-dark form-select form-select-sm"
                style={{
                  boxShadow: "none",
                  outline: "none",
                  lineHeight: "1.1",
                  height: "28px",
                  cursor: "pointer",
                  width: "80px",
                  paddingTop: "0",
                  paddingBottom: "0",
                }}
                value={itemsPerPage}
                onChange={(e) => {
                  setItemsPerPage(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                <option value="5">Show 5</option>
                <option value="10">Show 10</option>
                <option value="25">Show 25</option>
              </select>
            </div>

            {/* Search */}
            <div className="position-relative" style={{ width: "280px" }}>
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-100 ps-3 pe-5 py-2 border rounded form-control"
              />
              <Search
                size={18}
                className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
                style={{ pointerEvents: "none" }}
              />
            </div>
          </div>

          {/* Table Container */}
          <div className="card-body p-0">
            {/* Table */}
            <div className="table-responsive">
              <table className="table table-hover mb-0 text-center">
                <thead>
                  <tr>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      S.No
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      User ID
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      User Name
                    </th>
                   
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      Mobile Number
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      Role
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      Branch
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      Status
                    </th>
                    <th
                      style={{ backgroundColor: "#d3d3d3" }}
                      className="p-3 fw-semibold small"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.length > 0 ? (
                    currentUsers.map((user, index) => (
                      <tr key={index} style={{ fontSize: "14px" }}>
                        <td>{startIndex + index + 1}</td>
                        <td>{user.user_id}</td>
                        <td>{user.user_Name}</td>
                
                        <td>{user.mobile_Number}</td>
                        <td>{user.role}</td>
                        <td>{user.branch_Name}</td>
                        <td className="small">
                          <span
                            className={`d-inline-flex align-items-center gap-1 px-2 py-1 rounded-pill small fw-medium ${
                              user.status === "Active"
                                ? "bg-success bg-opacity-10 text-success"
                                : "bg-danger bg-opacity-10 text-danger"
                            }`}
                          >
                            {user.status}
                          </span>
                        </td>
                        <td className="small">
                          <div className="d-flex justify-content-center">
                            {privileges === 'Admin' && (
                              <button
                                onClick={() =>
                                  openDeleteModal(user.id, user.user_id)
                                }
                                className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                disabled={isLoading}
                              >
                                <Trash2 size={16} />
                              </button>
                            )}
                            {(privileges === 'Admin' || privileges === 'Manager') && (
                              <button
                                onClick={() => openUpdateModal(user.id, user)}
                                className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                                disabled={isLoading}
                              >
                                <Edit2 size={16} />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center p-5">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {itemsPerPage < filteredUsers.length && (
              <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`btn btn-sm d-flex align-items-center gap-2 ${
                    currentPage === 1
                      ? "bg-light text-muted"
                      : "bg-white text-dark"
                  }`}
                >
                  <FaChevronLeft size={14} />
                  <span className="ms-1 d-none d-md-inline">Previous</span>
                </button>

                <div className="d-flex gap-1">
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }

                    return (
                      <button
                        key={pageNum}
                        onClick={() => setCurrentPage(pageNum)}
                        disabled={isLoading}
                        className={`btn btn-sm ${
                          pageNum === currentPage
                            ? "bg-danger bg-opacity-10 text-danger"
                            : "bg-white text-dark"
                        }`}
                        style={{ width: "32px", height: "32px" }}
                      >
                        {pageNum}
                      </button>
                    );
                  })}
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <span className="px-2 py-1">...</span>
                  )}
                  {totalPages > 5 && currentPage < totalPages - 2 && (
                    <button
                      onClick={() => setCurrentPage(totalPages)}
                      disabled={isLoading}
                      className={`btn btn-sm ${
                        totalPages === currentPage
                          ? "bg-danger bg-opacity-10 text-danger"
                          : "bg-white text-dark"
                      }`}
                      style={{ width: "32px", height: "32px" }}
                    >
                      {totalPages}
                    </button>
                  )}
                </div>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`btn btn-sm d-flex align-items-center gap-2 ${
                    currentPage === totalPages
                      ? "bg-light text-muted"
                      : "bg-white text-dark"
                  }`}
                >
                  <span className="ms-1 d-none d-md-inline">Next</span>
                  <FaChevronRight size={14} />
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Add User Modal */}
        <div
          className={`modal fade ${showAddModal ? "show" : ""}`}
          style={{
            display: showAddModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="addUserModalLabel"
          aria-hidden={!showAddModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0  fw-semibold">Add User</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeAddModal}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      User ID
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        formErrors.user_id ? "is-invalid" : ""
                      }`}
                      name="user_id"
                      value={formData.user_id}
                      onChange={(e) =>
                        setFormData({ ...formData, user_id: e.target.value })
                      }
                      placeholder="Enter User ID"
                      disabled={isLoading}
                    />
                    {formErrors.user_id && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.user_id}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      User Name
                    </label>
                    <input
                      type="text"
                      className={`form-control form-control-sm ${
                        formErrors.user_Name ? "is-invalid" : ""
                      }`}
                      name="user_Name"
                      value={formData.user_Name}
                      onChange={(e) =>
                        setFormData({ ...formData, user_Name: e.target.value })
                      }
                      placeholder="Enter User Name"
                      disabled={isLoading}
                    />
                    {formErrors.user_Name && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.user_Name}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      className={`form-control form-control-sm ${
                        formErrors.mobile_Number ? "is-invalid" : ""
                      }`}
                      name="mobile_Number"
                      value={formData.mobile_Number}
                      onChange={(e) => {
                        // Remove all non-digit characters
                        const onlyDigits = e.target.value.replace(/\D/g, "");
                        setFormData({ ...formData, mobile_Number: onlyDigits });
                      }}
                      placeholder="Enter Mobile Number"
                      disabled={isLoading}
                      maxLength="10"
                    />

                    {formErrors.mobile_Number && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.mobile_Number}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Password
                    </label>
                    <input
                      type="password"
                      className={`form-control form-control-sm ${
                        formErrors.password ? "is-invalid" : ""
                      }`}
                      name="password"
                      value={formData.password}
                      onChange={(e) =>
                        setFormData({ ...formData, password: e.target.value })
                      }
                      placeholder="Enter Password"
                      disabled={isLoading}
                    />
                    {formErrors.password && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.password}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Role
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        formErrors.role ? "is-invalid" : ""
                      }`}
                      name="role"
                      value={formData.role}
                      onChange={(e) =>
                        setFormData({ ...formData, role: e.target.value })
                      }
                      disabled={isLoading}
                    >
                      <option value="" disabled>
                        Select Role
                      </option>
                      <option>Admin</option>
                      <option>Manager</option>
                      <option>Staff</option>
                    </select>
                    {formErrors.role && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.role}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Branch
                    </label>
                    <select
                      className={`form-select form-select-sm ${
                        formErrors.branch_Name ? "is-invalid" : ""
                      }`}
                      name="branch_Name"
                      value={formData.branch_Name}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          branch_Name: e.target.value,
                        })
                      }
                      disabled={isLoading}
                    >
                      <option value="" disabled>
                        Select Branch
                      </option>
                      {branch.map((branch, index) => (
                        <option key={index} value={branch.branch_name}>
                          {branch.branch_name}
                        </option>
                      ))}
                    </select>
                    {formErrors.branch_Name && (
                      <div className="invalid-feedback d-block small">
                        {formErrors.branch_Name}
                      </div>
                    )}
                  </div>

                  <div className="col-md-6 mt-3">
                    <label className="form-label small fw-medium">Status</label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={formData.status}
                      onChange={(e) =>
                        setFormData({ ...formData, status: e.target.value })
                      }
                      disabled={isLoading}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={closeAddModal}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleAddConfirm}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Update User Modal */}
        <div
          className={`modal fade ${showUpdateModal ? "show" : ""}`}
          style={{
            display: showUpdateModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="updateUserModalLabel"
          aria-hidden={!showUpdateModal}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content rounded"
              style={{ backgroundColor: "rgb(255, 240, 245)" }}
            >
              <div className="modal-header bg-pink-light border-bottom-0">
                <h5 className="modal-title m-0  fw-semibold">Update User</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeUpdateModal}
                  disabled={isLoading}
                ></button>
              </div>

              <div className="modal-body bg-pink-light">
                <div className="row">
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      User ID
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="user_id"
                      value={updateData.user_id}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          user_id: e.target.value,
                        })
                      }
                      placeholder="Enter User ID"
                      disabled={isLoading}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium">
                      User Name
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      name="user_Name"
                      value={updateData.user_Name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          user_Name: e.target.value,
                        })
                      }
                      placeholder="Enter User Name"
                      disabled={isLoading}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Mobile Number
                    </label>
                    <input
                      type="tel"
                      className="form-control form-control-sm"
                      name="mobile_Number"
                      value={updateData.mobile_Number}
                      onChange={(e) => {
                        // Keep only digits, max 10
                        const digitsOnly = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setUpdateData({
                          ...updateData,
                          mobile_Number: digitsOnly,
                        });
                      }}
                      placeholder="Enter Mobile Number"
                      disabled={isLoading}
                      maxLength={10}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Password
                    </label>
                    <input
                      type="password"
                      className="form-control form-control-sm"
                      name="password"
                      value={updateData.password}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          password: e.target.value,
                        })
                      }
                      placeholder="Enter Password"
                      disabled={isLoading}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Role
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="role"
                      value={updateData.role}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, role: e.target.value })
                      }
                      disabled={isLoading}
                    >
                      <option value="">Select Role</option>
                      <option>Admin</option>
                      <option>Manager</option>
                      <option>Staff</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label small fw-medium mt-2">
                      Branch
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="branch_Name"
                      value={updateData.branch_Name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          branch_Name: e.target.value,
                        })
                      }
                      disabled={isLoading}
                    >
                      <option value="" disabled>
                        Select Branch
                      </option>
                      {branch.map((item, index) => (
                        <option key={index} value={item.branch_name}>
                          {item.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-6 mt-3">
                    <label className="form-label small fw-medium mt-2">
                      Status
                    </label>
                    <select
                      className="form-select form-select-sm"
                      name="status"
                      value={updateData.status}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, status: e.target.value })
                      }
                      disabled={isLoading}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={closeUpdateModal}
                  disabled={isLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success"
                  onClick={handleUpdateSubmit}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{
            display: showDeleteModal ? "block" : "none",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          aria-labelledby="deleteConfirmModalLabel"
          aria-modal="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-confirm">
            <div className="modal-content">
              <div className="modal-body text-center">
                <div className="d-flex justify-content-center mb-3">
                  <div
                    className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                  </div>
                </div>
                <h4 className="modal-title mb-3">Are you sure?</h4>
                <h6 className="mb-4">
                  Do you really want to delete user{" "}
                  <span className="text-primary">({deleteName})</span>
                  ?
                </h6>
                <div className="d-flex btn-group">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm flex-grow-1"
                    onClick={closeDeleteModal}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm flex-grow-1 mx-2"
                    onClick={handleDelete}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Deleting...
                      </>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Users;
